export const makeDefault = (property) => (imp) => ({
    default: imp[property],
});
